if($('.type-detail').length){
    $('.p-image').append($('.product-top>.col-xs-12:not(.col-lg-6)>.p-detail-info .flags').clone())
    $('.p-info-wrapper').append($('.p-detail .p-detail-inner .p-detail-inner-header').clone(), $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info').clone())
    if($('.product-top .price-save').length){
        $('.product-top .price-save>span').each(function(){
            $(this).html($(this).html().replace('až', '<span class="small">až</span>'))
        })
    }
    $('.p-info-wrapper').append('<div class="customCart"><div class="inner"></div></div>');
    $('.customCart .inner').prepend($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'))
    if($('.extended-description table tr:contains("Top vlastnosti")').length>0){
        $('.extended-description table tr:contains("Top vlastnosti")').hide();
        $('.p-info-wrapper').append('<div class="topFeatures"><div class="topFeaturesProduct"></div></div>');
        if($('.admin-logged').length){
            $('.p-info-wrapper').append('<div class="adminTopFeatures"><div>Tento text vidí jen admin a je to klíč k top vlastnostem produktu<br>formát souboru musí být vždy .svg a cesta k souboru bude /user/documents/upload/detail-nemazat/top-vlastnosti/</div><div class="AdmintopfeaturesProduct"></div></div>')
        }
        var TopFeatures = $('.extended-description table tr:contains("Top vlastnosti") td').text().split(',');
        TopFeatures.forEach(function(text) {
            var withoutdiacritics = text.trim().replace('<br>', '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '-').toLowerCase();
            var imageRoad = '/user/documents/upload/detail-nemazat/top-vlastnosti/top_'+withoutdiacritics+'.svg?v='+new Date().getMinutes()
            $('.topFeaturesProduct').append('<div class="' + withoutdiacritics.toLowerCase() + '"><div class="wrapper"><div class="wrapperInner"><img src="'+imageRoad+'"></div></div><p>'+text.trim()+'</p></div>');
            if($('.admin-logged').length){
                $('.AdmintopfeaturesProduct').append('<div class="feature">Jméno top vlastnosti: '+text.replace('<br>', '')+'<br>Název souboru: top_'+withoutdiacritics.toLowerCase()+'</div>')
            }
        });
    }
    $('.extended-description table tr:contains("Kategorie")').hide();
  //  if($('.extended-description table tr:contains("Motiv")').length>0){
  //      var motiv = $('.extended-description table tr:contains("Motiv")').find('td').text().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '-').toLowerCase();
   //     $('.p-info-wrapper').append('<div class="customMotiv"><img src="/user/documents/upload/detail-nemazat/motiv/motiv_'+motiv+'.svg?v='+new Date().getMinutes()+'" alt="'+$('.p-detail h1').first().text().trim()+'"></div>')
   // }
    if($('.extended-description table tr:contains("Vykrajovací kolečko prodáváme samostatně. <br>Chcete ho koupit?")').length>0){
        $('.extended-description table tr:contains("Vykrajovací kolečko prodáváme samostatně. <br>Chcete ho koupit?")').hide();
        var circleTitle = $('.extended-description table tr:contains("Vykrajovací kolečko prodáváme samostatně. <br>Chcete ho koupit?") th').text().replace(':', '').replace('?', '')
        var circleText = $('.extended-description table tr:contains("Vykrajovací kolečko prodáváme samostatně. <br>Chcete ho koupit?") th .question-tooltip').attr('title');
        var circleButton = $('.extended-description table tr:contains("Vykrajovací kolečko prodáváme samostatně. <br>Chcete ho koupit?") td').text().trim()
        $('.p-info-wrapper').append('<div class="circleRow"><div class="h6">'+circleTitle+'<span class="show-tooltip question-tooltip" title="'+circleText+'" data-original-title="'+circleText+'">?</span></div><span class="btn btn-primary showCircles">'+circleButton+'</span></div>')
        $('html').on('click', '.showCircles', function() {
            var encodedCodes = idkolecka.map(c => encodeURIComponent(c)).join(',');
            $.ajax({
                url: 'https://php.shopcode.cz/api/vykrajovatka/api-products.php?codes=' + encodedCodes,
                method: 'GET',
                dataType: 'json',
                success: function(data) {
                    var main = data[0];
                    const firstParamName = Object.keys(main.parameters)[0];
                    const valid = data.filter(p => p.price > 0);
                    const minPrice = Math.min(...valid.map(p => p.price));
                    var html = `
                        <div class="customCircleProduct">
                            <div class="left">
                                <img src="${main.image}" alt="${main.name}">
                            </div>
                            <div class="right">
                                <h2 >${main.name}</h2>
                                <div class="description">${main.short_description}</div>
                                
                                <div class="variants">
                                    <p>${firstParamName}:</p>
                                    
                        `;

                        // přidáme varianty
                     
                       data.forEach(function(p) {
                            const [paramName, paramValue] = Object.entries(p.parameters)[0] || ['', ''];

                            html += `
                                
                                    <span data-code="${p.code}" data-price="${p.price}" data-stock=${p.availability_in_stock}>
                                        ${paramValue}
                                    </span>
                               
                            `;
                        });
                        html += `
                                </div>
                                <div class="avail">
                                    <span class="availLabel">Dle zvolené varianty</span>
                                </div>
                                <div class="bottom">
                                    <div class="price">
                                        <span class="price">od ${Number(minPrice).ShoptetFormatAsCurrency()}</span>
                                    </div>
                                    <div class="addtoCart noAddToCart">
                                        <div class="customQuantity">
                                            <span class="minus">-</span>
                                            <input type="number" value="1" class="customAmount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999">
                                            <span class="plus">+</span>
                                        </div>
                                        <span class="btn add-to-cart-button">Přidat do košíku</span>
                                    </div>
                                </div>
                            </div>
                        </div>`;

                        // zobrazíme v colorboxu
                        if($('body.mobile').length){
                            $.colorbox({
                                html: html,
                                maxWidth: shoptet.modal.config.maxWidth,
                                maxHeight: shoptet.modal.config.maxHeight,
                                height:shoptet.modal.config.maxHeight,
                                width: shoptet.modal.config.widthLg,
                                className: shoptet.modal.config.classLg + ' productDetailPopupVykrajovatka',
                            });
                        }
                        else{
                            $.colorbox({
                                html: html,
                                maxWidth: shoptet.modal.config.maxWidth,
                                maxHeight: shoptet.modal.config.maxHeight,
                                height:shoptet.modal.config.initialHeight,
                                width: shoptet.modal.config.widthLg,
                                className: shoptet.modal.config.classLg + ' productDetailPopupVykrajovatka',
                            });
                        }
                        
                    

                   
                },
                error: function(xhr, status, error) {
                   
                }
            });
        });
    }
    
     $('.stars-label').each(function() {
        var text = $(this).text();
        if (text.indexOf('(Již jste hlasovali)') !== -1) {
            $(this).text(text.replace('(Již jste hlasovali)', ''));
        }
    });
    $('.parameter-dependent').each(function(){
        if($(this).text().trim() === 'Zvolte variantu'){
            $(this).text('Dle velikosti')
        }
    });
    $('.delivery-time').each(function(){
        if($(this).text().trim() === 'Dle varianty'){
            $(this).text('Dle velikosti')
        }
    });
    $('.p-info-wrapper .delivery-time').closest('tr').hide()
    $('.p-info-wrapper').append('<div class="stockLine"></div>')
    if($('.p-info-wrapper .delivery-time').length>0){
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .delivery-time').closest('th').html())
    }
    else{
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .shipping-options'))
       
    }
    
    if($('.variant-list').length>0){
        $('.variant-list select').each(function(){
            var optionLength = $(this).find('option').length
            var data_parameter_id = $(this).data('parameter-id')
            var html_var = '<div class="custom-variant"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
            html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
            $(this).find('option').each(function(){
                var data_value = $(this).attr('value')
                
                if ($.isNumeric($(this).val())) {
                    const originalText = $(this).text();
                    const highlightedText = originalText.replace(/(\d+)/g, '<span class="number">$1</span>');
                    html_var += '<div class="variant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                    html_var += '<div class="text">'+highlightedText+'</div>'
                    html_var += '</div>'
                }
            })
            html_var += '</div></div>'
            $(this).after(html_var)
            $(this).closest('.variant-list select').hide()
           $(this).closest('.variant-list span').hide()
          
        })

        var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
        for (var parentKey in necessaryVariantData) {
            if (necessaryVariantData.hasOwnProperty(parentKey)) {
                var variant = necessaryVariantData[parentKey];
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
            }
        }
        
    }
    if($('.surcharge-list select[data-parameter-name="Vyberte motiv"]').length){
        $('.p-info-wrapper').append(`
        <div class="motivRow">
            <div class="left">
                <div class="h5">${$('select[data-parameter-id="38"]').attr('data-parameter-name')}</div>
                <div class="chooseMotiv"><span></span></div>
            </div>
            <div class="right">
            <div class="h5">Přidejte vlastní text</div>
            <div class="wrapper">
                <label for="customText">Maximální délka textu je ${countInput} znaků.</label>
                <input id="customText" name="customText"  maxlength="${countInput}" type="text" placeholder="Sem vepište vámi požadovaný text.">
                <div id="charCounter" class="char-counter"></div>
            </div>
                </div>
        </div>`);
        var chooseMotiv = ''
        $('.surcharge-list select[data-parameter-name="Vyberte motiv"]').each(function(){
            var data_parameter_id = $(this).data('parameter-id')
            chooseMotiv += '<div class="customSurcharge">'
            chooseMotiv += '<div class="customSurchargeWrap" data-param-id="'+data_parameter_id+'">'
            $(this).find('option').each(function(){
                var data_value = $(this).attr('value')
                if ($.isNumeric($(this).val())) {
                    const originalText = $(this).text().split('+')[0].trim();
                    var customImage = originalText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
                    chooseMotiv += '<div class="surcharge" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                    chooseMotiv += '<div class="image"><img src="/user/documents/upload/detail-nemazat/parametry/'+customImage+'.jpg" alt="'+originalText+'"></div>'
                    chooseMotiv += '</div>'
                }
            })
            chooseMotiv += '</div>'
            chooseMotiv += '<div class="bottom text-center"><p>'+motivText+'</p><p class="text-center"><a href="/zakazkova-vyroba/" class="btn btn-secondary">Napište nám</a></p></div>'
            chooseMotiv += '</div>'           
            $(this).closest('.surcharge-list').hide()
        });
        var max = parseInt($('#customText').attr('maxlength'), 10);
        $('#customText').on('input', updateCounter);
    }




    $(document).ready(function(){
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
             $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })

    $(".stockLine").append($(".customMotiv"));
}


$(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })

$('html').on('click', '.customCircleProduct .variants span', function(){
    var circleCode = $(this).attr('data-code');
    var circlePrice = $(this).attr('data-price');
    var circleStock = $(this).attr('data-stock');
    if(circleStock === 'Skladem'){
        var circleColor = '#3c840f';
        $('.customCircleProduct .bottom .addtoCart').removeClass('noAddToCart');
    }
    else{
        var circleColor = '#d00000';
        $('.customCircleProduct .bottom .addtoCart').addClass('noAddToCart')
    };
    $('.customCircleProduct .variants span').removeClass('active');
    $(this).toggleClass('active');
    $('.customCircleProduct .avail .availLabel').attr('style', 'color:'+circleColor).text(circleStock);
    $('.customCircleProduct .bottom .price').html(Number(circlePrice).ShoptetFormatAsCurrency());
    
})

$('html').on('click', '.customCircleProduct .customQuantity span', function() {
    const $btn = $(this);
    const $wrap = $btn.closest('.customQuantity');
    const $input = $wrap.find('input[type="number"]');
    const step = parseFloat($input.attr('step')) || 1;
    const min = parseFloat($input.attr('min')) || 0;
    const max = parseFloat($input.attr('max')) || Infinity;
    let value = parseFloat($input.val()) || 0;
    if ($btn.hasClass('plus')) {
        value += step;
    } else if ($btn.hasClass('minus')) {
        value -= step;
    }
    if (value < min) value = min;
    if (value > max) value = max;
    $input.val(value).trigger('change');
});

$('html').on('click', '.customCircleProduct .addtoCart span.add-to-cart-button', function() {
    var countInput = $('.customCircleProduct .addtoCart .customQuantity input').val();
    var codeCircle = $('.customCircleProduct .variants span.active').attr('data-code');
    shoptet.cartShared.addToCart({productCode: ''+codeCircle+'', amount: countInput}, true);
    $.colorbox.close()
});

$('html').on('click', '.motivRow .chooseMotiv', function(){
    $.colorbox({
        html: chooseMotiv,
        maxWidth: shoptet.modal.config.maxWidth,
        maxHeight: shoptet.modal.config.maxHeight,
        height:'800px',
        width: shoptet.modal.config.widthLg,
        className: shoptet.modal.config.classLg + ' productDetailPopupMotiv',
    });
})

$('html').on('click', '.customSurcharge .customSurchargeWrap .surcharge', function(){
    const variantData = $(this).data('value');
    const variantParameterId = $(this).data('parameter-id');
    $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
        return $(this).attr('value') == variantData;
    }).change().prop("selected", true);
    $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
    $(this).addClass("active"); 
    var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
    var $splitParameters = $(selector);
    $splitParameters.trigger('change');
    $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    $('.chooseMotiv').html($(this).find('.image').html());
    $.colorbox.close()
})

function getZnakWord(num) {
    if (num === 1) return 'znak';
    if (num >= 2 && num <= 4) return 'znaky';
    return 'znaků';
}

function updateCounter() {
        var remaining = max - $('#customText').val().length;
        if (remaining > 0) {
            $('#charCounter').text('Zbývá ' + remaining + ' ' + getZnakWord(remaining) + '.').removeClass('warning');
        } else {
            $('#charCounter').text(countMessage).addClass('warning');
            $('#customText').addClass('shake');
            setTimeout(function() {
                $('#customText').removeClass('shake');
            }, 400);
        }
}
if($('.surcharge-list select[data-parameter-name="Vyberte motiv"]').length){
$('html').on('click', '.add-to-cart .add-to-cart-button', function(e){
    const $select=$('.surcharge-list select.surcharge-parameter');
    const selectedVal=$select.val();
    if(!selectedVal){
        e.preventDefault();
        $('.p-info-wrapper .surcharge-error').remove();
        $('.p-info-wrapper').prepend(`<div class="surcharge-error">${errorMesage}</div>`);
        return;
    }
    $('.p-info-wrapper .surcharge-error').remove();
    const $input = $('.p-info-wrapper .motivRow input#customText');
    const productCode = $('.p-info-wrapper .p-detail-inner-header .p-code span:not(.p-code-label):not(.no-display)').text().trim();
    const value=$input.val().trim();
    if(!productCode||!value)return;
    let stored=JSON.parse(localStorage.getItem('mhCustomTexts')||'{}');
    if(!stored[productCode])stored[productCode]=[];
    if(!stored[productCode].includes(value))stored[productCode].push(value);
    localStorage.setItem('mhCustomTexts',JSON.stringify(stored));
    $input.val('');
});
}